import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { createAlert, clearAlerts } from '../scripts/createAlert';

let waitForItModal;

export default class extends Controller {
  static targets = [
    "container", "requiredContent","waitForTheMagicModal", "synopsis", "synopsisTextArea",
    "generateSynopsisButton", "newDraftButton", "generateDraftButton", "saveButton", "data",
    "sortable", "articleType", "requiredDataMessage"
  ]
  static values = {
    article: Number,
    baseUrl: String
  }

  connect() {
    // console.log("Hello, Articles Controller here!", this.element)
    // console.log('container', this.containerTarget)
    // console.log('save button', this.saveButtonTarget)
    // console.log('data', this.dataTargets)

    if (this.hasWaitForTheMagicModalTarget) {
      waitForItModal = new bootstrap.Modal(this.waitForTheMagicModalTarget);
    }

    if(!this.isAllRequiredDataFilledOut()) {
      this.newDraftButtonTarget.setAttribute('disabled', true);
    } else {
      this.hasRequiredDataMessageTarget && this.requiredDataMessageTarget.classList.add('d-none');
    }

    this.sortableTargets.forEach(elm => {
      Sortable.create(elm, {
        draggable: '.data-sortable',
        dataIdAttr: 'data-sortable-id',
        handle: ".sortable-handle",  // Drag handle selector within list items

        // Changed sorting within list
        onUpdate: (event) => {
          const rows = event.target.querySelectorAll('.row.data-sortable');
          const attachmentIds = Array.from(rows).map(elm => elm.dataset.attachmentId)

          const token = $('meta[name="csrf-token"]').attr('content');
          $.ajaxSetup({
            beforeSend: function (xhr) {
              xhr.setRequestHeader('X-CSRF-Token', token);
            }
          });

          $.post(`/articles/${this.articleValue}/data/reorder`, { ordered_data_ids: attachmentIds }).then(() => {
            createAlert('success', 'Data order updated')
          })
        }
      });
    })
  }

  fetchTypes(event) {
    const categoryId = event.target.value;

    if (categoryId) {
      // Enable type select
      this.articleTypeTarget.disabled = false;

      // Fetch types for selected category
      fetch(`/article_categories/${categoryId}/types`)
        .then(response => response.json())
        .then(types => {
          // Clear existing options
          this.articleTypeTarget.innerHTML = '<option value="">Select a type</option>';

          // Add new options
          types.forEach(type => {
            const option = new Option(type.title, type.id);
            this.articleTypeTarget.add(option);
          });
        })
        .catch(error => console.error('Error fetching types:', error));
    } else {
      // Disable and clear type select
      this.articleTypeTarget.disabled = true;
      this.articleTypeTarget.innerHTML = '<option value="">Select a type</option>';
    }
  }

  toggleData(event) {
    // console.log('Event triggered', event.target);

    if (event.target.classList.contains('submenu-button-container')) {
      return;
    }

    const toggleButton = event.target.nextElementSibling;
    toggleButton && toggleButton.click();
  }

  // addData(event) {
  //   if (event.target.classList.contains('disabled')) {
  //     return;
  //   }

  //   fetch(`/articles/${this.articleValue}/data/new`).then(res => res.text()).then(partial => {
  //     this.containerTarget.insertAdjacentHTML( 'beforeend', partial );

  //     // add focus to newly created input
  //     this.dataTargets[this.dataTargets.length - 1].querySelector('input').focus();

  //     if (this.dataTargets.length >= 3) {
  //       this.saveButtonTarget.removeAttribute('disabled');
  //     }
  //   });
  // }

  cleanPastedContent(event) {
    // Prevent the default paste behavior
    event.preventDefault();

    // Get the clipboard data
    let pasteData = (event.clipboardData || window.clipboardData).getData('text');

    // use the DOM parser to remove HTML for us
    let doc = new DOMParser().parseFromString(pasteData, 'text/html');
    pasteData = doc.body.textContent || "";

    // Modify the pasted content, e.g., trimming and uppercasing
    // pasteData = pasteData.trim().toUpperCase();  // Example modification

    // Insert the modified content using execCommand to preserve undo functionality
    // Yes, I know it deprecated, but according to my overlord ChatGPT its still the best way
    // to preserve undo functionality.
    if (document.queryCommandSupported('insertText')) {
      document.execCommand('insertText', false, pasteData);
    } else {
      // Fallback for browsers that do not support execCommand('insertText')
      const start = event.target.selectionStart;
      const end = event.target.selectionEnd;
      const currentValue = event.target.value;
      event.target.value = currentValue.slice(0, start) + pasteData + currentValue.slice(end);
      event.target.setSelectionRange(start + pasteData.length, start + pasteData.length);
    }
  }

  generateSynopsis(event) {

    if (event.target.dataset.confirmSwal) {
      // need to confirm first
      return;
    }

    this.generateSynopsisButtonTarget.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Generating...';

    fetch(`/${this.baseUrlValue}/synopsis_help`).then(res => res.json()).then(data => {

      this.synopsisTextAreaTarget.value = data.text;
      this.synopsisTextAreaTarget.dispatchEvent(new Event("keyup"));
      this.synopsisTextAreaTarget.focus();

      this.generateSynopsisButtonTarget.dataset.confirmSwal = "Are you sure?"
      this.generateSynopsisButtonTarget.dataset.text = "Re-generating a synopsis will remove the existing text and it cannot be recovered."
      this.generateSynopsisButtonTarget.innerHTML = '<i class="fas fa-magic"></i> Generate Synopsis';
    });
  }

  isAllRequiredDataFilledOut() {
    let allRequiredDataFilledOut = true;
    this.requiredContentTargets.forEach(elm => {

      if (elm.value.trim() === "") {
        allRequiredDataFilledOut = false;
      }

    });

    return allRequiredDataFilledOut;
  }

  markRequiredDataAsInvalid() {

    this.requiredContentTargets.forEach(elm => {

      if (elm.value.trim() === "") {
        elm.setCustomValidity('This field is required');
        elm.classList.add('is-invalid');
      } else {
        elm.setCustomValidity('');
        elm.classList.remove('is-invalid');
      }

    });

  }

  attemptSubmit(event) {
    event.preventDefault();

    const form = event.target.closest('form');

    const allRequiredDataFilledOut = this.isAllRequiredDataFilledOut();

    // if not all require data is filled out, show the required tab and alert the user
    if (!allRequiredDataFilledOut) {
      this.markRequiredDataAsInvalid();
      document.getElementById('article-required-tab').click();
      createAlert('danger', 'Please fill out all required fields');
      waitForItModal.hide();
      return;
    }

    if (this.synopsisTextAreaTarget.value.trim() === "") {
      this.synopsisTextAreaTarget.classList.add('is-invalid');
      this.synopsisTextAreaTarget.focus();
    }

    if (form.checkValidity() && allRequiredDataFilledOut) {
      this.synopsisTextAreaTarget.classList.remove('is-invalid');
      clearAlerts();
      form.submit();
    } else {
      waitForItModal.hide();
      createAlert('danger', 'Please fill out all required fields');
    }

  }
}
